import { Group, noop } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { Table } from "@tanstack/react-table"
import { ColumnManager, SearchInput } from "@tfg/ui"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  TABLE_CONTEXT_MAP,
  ViewHeader,
} from "~/components/table/views/ViewHeader"
import { FindContactResponseDto } from "~/gen/api"
import { useGetColumnManagerTranslations } from "~/hooks/table"

export const SupplierToolBar = ({
  table,
  isColumnManagerOpen,
  setIsColumnManagerOpen,
  searchSupplier,
  setSearchSupplier,
}: {
  table: Table<FindContactResponseDto>
  isColumnManagerOpen: boolean
  setIsColumnManagerOpen: Dispatch<SetStateAction<boolean>>
  searchSupplier: string
  setSearchSupplier: Dispatch<SetStateAction<string>>
}) => {
  const [localSearch, setLocalSearch] = useState<string>(searchSupplier)
  const columnManagerTranslations = useGetColumnManagerTranslations()

  const [debouncedSearch] = useDebouncedValue<string>(localSearch, 600)

  const { t } = useTranslation("organizationSettings")

  useEffect(() => {
    setSearchSupplier(debouncedSearch)
  }, [debouncedSearch, setSearchSupplier])

  useEffect(() => {
    setLocalSearch(searchSupplier)
  }, [searchSupplier])

  if (!table) return null

  return (
    <Group w="100%" justify="left">
      <SearchInput
        inputValue={localSearch}
        onChange={(value) => setLocalSearch(value)}
        onOpen={noop}
        placeholder={t("supplierSettings.searchSuppliers")}
      />
      <ColumnManager
        table={table}
        translations={columnManagerTranslations}
        isOpen={isColumnManagerOpen}
        setIsOpen={setIsColumnManagerOpen}
      />
      <ViewHeader
        tableContext={TABLE_CONTEXT_MAP.BUSINESS_PARTNERS_REPOSITORY}
      />
    </Group>
  )
}
